import React, { FC, useState } from 'react';
import { PlatformEnum } from 'src/shared/enums';
import { config } from 'config/config';
import { ComboData, IAddressData } from 'src/shared/models';
import AddressFormAr from 'src/components/account/addresses/ar/AddressFormAr';
import AddressFormCl from 'src/components/account/addresses/cl/AddressFormCl';
import AddressFormCo from 'src/components/account/addresses/co/AddressFormCo';
import AddressFormEs from 'src/components/account/addresses/es/AddressFormEs';
import AddressFormMx from 'src/components/account/addresses/mx/AddressFormMx';
import AddressFormPe from 'src/components/account/addresses/pe/AddressFormPe';
import AddressFormDe from 'src/components/account/addresses/de/AddressFormDe';
import AddressFormPt from 'src/components/account/addresses/pt/AddressFormPt';
import AddressFormIt from 'src/components/account/addresses/it/AddressFormIt';
import AddressFormBr from 'src/components/account/addresses/br/AddressFormBr';
import AddressFormFr from 'src/components/account/addresses/fr/AddressFormFr';

interface Props {
  address?: IAddressData;
  isEditForm?: boolean;
  isFirstAddress?: boolean;
  onCreateAddress?: (addressList: IAddressData) => void;
  onUpdateAddress?: (addressList: IAddressData) => void;
  regionList: ComboData[];
  departmentList?: ComboData[];
  provinceList?: ComboData[];
  districtList?: ComboData[];
  isLoading?: boolean;
}

export const AddressForm: FC<Props> = ({
  address,
  isEditForm,
  isFirstAddress,
  onCreateAddress,
  onUpdateAddress,
  regionList,
  departmentList,
  provinceList,
  districtList,
  isLoading = false,
}): JSX.Element => {
  const { PLATFORM } = config.APP;

  const addressFormByPlatform = () => {
    switch (PLATFORM) {
      case PlatformEnum.CON_ARGENTINA: {
        return (
          <AddressFormAr
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_BRAZIL: {
        return (
          <AddressFormBr
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_CHILE: {
        return (
          <AddressFormCl
            address={address as IAddressData}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList as ComboData[]}
            districtList={districtList as ComboData[]}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_COLOMBIA: {
        return (
          <AddressFormCo
            address={address as IAddressData}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList as ComboData[]}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_DEUTSCHLAND: {
        return (
          <AddressFormDe
            address={address as IAddressData}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList as ComboData[]}
            districtList={districtList as ComboData[]}
            provinceList={provinceList as ComboData[]}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_FRANCE: {
        return (
          <AddressFormFr
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_ITALY: {
        return (
          <AddressFormIt
            address={address as IAddressData}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList as ComboData[]}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_PERU: {
        return (
          <AddressFormPe
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            departmentList={departmentList}
            provinceList={provinceList}
            districtList={districtList}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_PORTUGAL: {
        return (
          <AddressFormPt
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            isLoading={isLoading}
          />
        );
      }
      case PlatformEnum.CON_MEXICO:
        return (
          <AddressFormMx
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            suburbList={districtList}
          />
        );
      case PlatformEnum.CON_SPAIN:
      default: {
        return (
          <AddressFormEs
            address={address}
            isEditForm={isEditForm}
            isFirstAddress={isFirstAddress}
            onCreateAddress={onCreateAddress}
            onUpdateAddress={onUpdateAddress}
            regionList={regionList}
            isLoading={isLoading}
          />
        );
      }
    }
  };

  return <>{addressFormByPlatform()}</>;
};

export default AddressForm;
